import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import DonationForm from './views/DonationForm.vue'
import Guidelines from './views/Guidelines.vue'
import Foundation from './views/Foundation.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
	},
	{
		path: '/donation-form',
		name: 'donation-form',
		component: DonationForm
	},
	{
		path: '/foundation',
		name: 'foundation',
		component: Foundation
	},
	{
		path: '/guidelines',
		name: 'guidelines',
		component: Guidelines
	}
  	],
	scrollBehavior(to, from, savedPosition) {
		return { x: 0, y: 0 }
	}
})
